// Structure du cours "Tempalte"
import courseImage from './course-image.jpg';

export const courseStructure = {
  id: 'morpion',
  title: 'Jeu 2 : Le Morpion',
  image: courseImage,
  chapters: [
    {
      id: 'introduction',
      title: 'Introduction',
      path: '/cours/morpion'
    },
    {
      id: 'chapitre1',
      title: 'Le plateau de jeu',
      path: '/cours/morpion/chapitre1'
    },
    {
      id: 'chapitre2',
      title: 'Détection de la case cliquée',
      path: '/cours/morpion/chapitre2'
    },
    {
      id: 'chapitre3',
      title: 'Le tableau en mémoire',
      path: '/cours/morpion/chapitre3'
    },
    {
      id: 'chapitre4',
      title: 'Remplir le plateau',
      path: '/cours/morpion/chapitre4'
    },
    {
      id: 'chapitre5',
      title: 'Détection du gagnant',
      path: '/cours/morpion/chapitre5'
    }
  ]
}; 